'use client';

import { ModalVideoPlayer } from '@/components/ModalVideoPlayer';
import { PlayCircleIcon } from '@heroicons/react/24/solid';
import { useState } from 'react';
import Image from 'next/image';
import videoSm from './SGC_WatchVideoBackground_SM.png';
import videoMd from './SGC_WatchVideoBackground_MD.png';
import videoLg from './SGC_WatchVideoBackground_LG.png';
import videoXl from './SGC_WatchVideoBackground_XL.png';

type VideoProps = {
  ctaText: string;
  videoLink: string;
};

export function Video({ ctaText, videoLink }: VideoProps) {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <section id="video">
      <div className="relative bg-dark-background text-white">
        <picture>
          <source srcSet={videoXl.src} type="image/png" media="(min-width: 1920px)" />
          <source srcSet={videoLg.src} type="image/png" media="(min-width: 1280px)" />
          <source srcSet={videoMd.src} type="image/png" media="(min-width: 768px)" />
          <source srcSet={videoSm.src} type="image/png" media="(min-width: 320px)" />
          <Image src={videoSm} alt="video preview" className="inset-0 h-full w-full object-cover" />
        </picture>
        <button
          onClick={openModal}
          className="text-body group absolute inset-0 flex flex-col items-center justify-center gap-2"
        >
          <PlayCircleIcon className="size-16 group-hover:text-gradle-blue" />
          <span className="text-h6 underline-text-transition-blue max-w-56 md:max-w-full">{ctaText}</span>
        </button>

        <ModalVideoPlayer isOpen={isOpen} videoLink={videoLink} onClose={closeModal} />
      </div>
    </section>
  );
}
